var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"mm-collapse",class:{ 'mm-show': _vm.open }},_vm._l((_vm.children),function(child){return _c('CountryTreeNode',{key:child.id,attrs:{"value":child,"filterStore":_vm.filterStore}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }